export default __webpack_public_path__ + "static/media/25120419.fd1eebb0.png";